const NON_REQUEST_ACTION_TYPES = [
    "vue-i18n-manager/UPDATE_CONFIGURATION",
    "vue-i18n-manager/SET_LANGUAGE",
    "setting/GET_TRANSLATIONS",
    "setting/GET_LOCATION_DATA",
    "setting/GET_CURRENCY_LIST",
    "vue-i18n-manager/SET_TRANSLATION",
];

const LONG_TIMEOUT_MS = 15000;

function isRequestInBlacklist(action) {
    return action.type && NON_REQUEST_ACTION_TYPES.indexOf(action.type) === -1;
}

export default function createRequestsPlugin() {
    return store => {
        let requestsCount = 0;
        let allRequestsCompleted = new Promise(resolve => {
            store.subscribeAction({
                before: action => {
                    if (!isRequestInBlacklist(action)) return;
                    // console.log("add: ", requestsCount, action);
                    requestsCount++;
                },
                after: action => {
                    if (!isRequestInBlacklist(action)) return;
                    requestsCount--;
                    // console.log("remove: ", requestsCount, action);
                    if (requestsCount === 0) {
                        resolve();
                    }
                },
            });
        });
        Promise.race([allRequestsCompleted, new Promise(resolve => setTimeout(resolve, LONG_TIMEOUT_MS))]).then(() =>
            store.commit("setAllRequestsCompleted", true)
        );
    };
}
